import React, { useEffect, useState } from "react";

const Alert = ({ alert }) => {
  return (
    <>
      <span className={alert.type}>{alert.msg}</span>
    </>
  );
};

export default Alert;
